var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-content-wrapper"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlBody)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }